import { render, staticRenderFns } from "./Restless.vue?vue&type=template&id=924472a0&scoped=true&"
import script from "./Restless.vue?vue&type=script&lang=js&"
export * from "./Restless.vue?vue&type=script&lang=js&"
import style0 from "./Restless.vue?vue&type=style&index=0&id=924472a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924472a0",
  null
  
)

export default component.exports